// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/woff/Pretendard-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/woff/Pretendard-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/woff/Pretendard-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/fonts/woff/Pretendard-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/fonts/ttf/Courier-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/fonts/ttf/Courier-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/fonts/ttf/Courier-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/fonts/ttf/IBMPlexMono-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/fonts/ttf/IBMPlexMono-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/fonts/ttf/IBMPlexMono-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/fonts/ttf/IBMPlexMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
          user-select: none;
}

body {
  margin: 0;
}

.App {
  max-width: 1000px;
  /* max-width: 450px; */
  min-height: 100vh;
  position: relative;
  width: 100vw;
  margin: 0 auto;
}

button {
  background-color: inherit;
  border: none;
  outline: none;
  cursor: pointer;
}

.container {
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding: 60px 24px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  overflow: hidden;
  scrollbar-width: none;
  position: relative;
  box-sizing: border-box;
}

.rotating-icon {
  animation: rotate 2s linear;
}

.rotating-icon-repeat {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

*::-webkit-scrollbar {
  display: none;
}

.pincodeBtn:active{
  background-color: #313131;
  border-radius: 50%;
}

.custom-select .ant-select-selector {
  padding: 0px 3px 0px 4px !important; 
}


@font-face {
  font-family: 'Pretendard-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Pretendard-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Pretendard-SemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Pretendard-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Courier-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Courier-BoldItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Courier-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'IBMPlexMono-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'IBMPlexMono-Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'IBMPlexMono-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'IBMPlexMono-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

.react-datepicker__input-container input {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE,iCAAiC;EACjC,2DAAqE;EACrE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2DAAkE;EAClE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2DAAsE;EACtE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2DAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+DAAiE;EACjE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+DAAqE;EACrE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,+DAAuE;EACvE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gEAAwE;EACxE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["* {\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n}\n\nbody {\n  margin: 0;\n}\n\n.App {\n  max-width: 1000px;\n  /* max-width: 450px; */\n  min-height: 100vh;\n  position: relative;\n  width: 100vw;\n  margin: 0 auto;\n}\n\nbutton {\n  background-color: inherit;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.container {\n  width: 100%;\n  height: auto;\n  min-height: 100vh;\n  padding: 60px 24px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n  overflow: hidden;\n  scrollbar-width: none;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.rotating-icon {\n  animation: rotate 2s linear;\n}\n\n.rotating-icon-repeat {\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n*::-webkit-scrollbar {\n  display: none;\n}\n\n.pincodeBtn:active{\n  background-color: #313131;\n  border-radius: 50%;\n}\n\n.custom-select .ant-select-selector {\n  padding: 0px 3px 0px 4px !important; \n}\n\n\n@font-face {\n  font-family: 'Pretendard-Regular';\n  src: url('/public/fonts/woff/Pretendard-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Pretendard-Bold';\n  src: url('/public/fonts/woff/Pretendard-Bold.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Pretendard-SemiBold';\n  src: url('/public/fonts/woff/Pretendard-SemiBold.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Pretendard-Medium';\n  src: url('/public/fonts/woff/Pretendard-Medium.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Courier-Regular';\n  src: url('/public/fonts/ttf/Courier-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Courier-BoldItalic';\n  src: url('/public/fonts/ttf/Courier-BoldItalic.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Courier-Bold';\n  src: url('/public/fonts/ttf/Courier-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'IBMPlexMono-Bold';\n  src: url('/public/fonts/ttf/IBMPlexMono-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'IBMPlexMono-Italic';\n  src: url('/public/fonts/ttf/IBMPlexMono-Italic.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'IBMPlexMono-Medium';\n  src: url('/public/fonts/ttf/IBMPlexMono-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'IBMPlexMono-Regular';\n  src: url('/public/fonts/ttf/IBMPlexMono-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.react-datepicker__input-container input {\n  padding: 10px;\n  box-sizing: border-box;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
